import { render, staticRenderFns } from "./fieldReportDetails.vue?vue&type=template&id=2b95426b&scoped=true"
import script from "./fieldReportDetails.vue?vue&type=script&lang=js"
export * from "./fieldReportDetails.vue?vue&type=script&lang=js"
import style0 from "./fieldReportDetails.vue?vue&type=style&index=0&id=2b95426b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b95426b",
  null
  
)

export default component.exports